export var AttachmentType;
(function (AttachmentType) {
    AttachmentType["DAT"] = "DAT";
    AttachmentType["IMAGE"] = "IMG";
    AttachmentType["THUMBNAIL"] = "THUMBNAIL";
    AttachmentType["EST_UMPDF"] = "EST_UMPDF";
    AttachmentType["EST_PDF"] = "EST_PDF";
    AttachmentType["EST_CCC_OBJECT"] = "EST_CCC_OBJECT";
    AttachmentType["EST_ADP_OBJECT"] = "EST_ADP_OBJECT";
    AttachmentType["MIE_ESTIMATE"] = "MIE_ESTIMATE";
    AttachmentType["EMS_ESTIMATE"] = "EMS_ESTIMATE";
    AttachmentType["IMAGE_PDF"] = "IMAGE_PDF";
    AttachmentType["VIDEO"] = "VIDEO";
    AttachmentType["SUPP_ANNOTATION_XML"] = "SUPP_ANNOTATION_XML";
})(AttachmentType || (AttachmentType = {}));
//# sourceMappingURL=AttachmentType.js.map